module.exports = __webpack_public_path__ + "media/images/logo_footer-ed5d84dcab03e03167d5b9d0f8613594.svg";